module.exports = __webpack_public_path__ + "2bc76787f56b38406ef0414b0501003f.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/orks-vignette-preview-320.jpg
// module id = 489
// module chunks = 0